var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
var Sub = function () {
    return (React.createElement(Style, null,
        React.createElement("aside", { className: "mediumSide", id: "asideMedium" })));
};
var Style = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    margin: 57px 0 0;\n    border-top: 2px solid #333;\n    background: #f6f6f8;\n    height: calc(100% - 57px);\n    z-index: 1;\n\n    /* \uC784\uC2DC css */\n    font-size: 12px;\n\n    .mediumBar .MdmBox .MdTit {\n        box-sizing: content-box;\n    }\n    .medium {\n        display: none;\n    }\n    .list:hover {\n        text-decoration: underline\n    }\n"], ["\n    position: relative;\n    margin: 57px 0 0;\n    border-top: 2px solid #333;\n    background: #f6f6f8;\n    height: calc(100% - 57px);\n    z-index: 1;\n\n    /* \uC784\uC2DC css */\n    font-size: 12px;\n\n    .mediumBar .MdmBox .MdTit {\n        box-sizing: content-box;\n    }\n    .medium {\n        display: none;\n    }\n    .list:hover {\n        text-decoration: underline\n    }\n"])));
export default Sub;
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// ./src/detail/components/sub/index.tsx
// module id = 279
// module chunks = 0